<template>
    <div>
        <v-row>
            <v-col cols="12" class="d-flex  justify-end align-center">
                <v-btn text x-small class="text-caption" color="primary" @click="readallNotif(datoLogin.id)">
                    Marcar todo como leido
                    <v-icon small right>fas fa-check-double</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col v-if="notificationslist.length < 1">
                <v-card outlined>
                    <v-card-text style="height: 80px;" class="d-flex justify-center align-center">
                        Sin notificaciones
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" v-for="item in notificationslist" :key="item.id" class="my-2" v-else>
                <v-card outlined color="light-gray">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12">
                                <v-row dense>
                                    <v-col cols="10" class="py-0 font-weight-black primary--text">
                                        <v-icon icon left x-small>
                                            {{ item.icon_notif }}
                                        </v-icon>
                                        {{ item.titulo_notif }}
                                    </v-col>
                                    <v-col cols="2" class="py-0 d-flex justify-end">
                                        <ButtonComp @click="readNotif(item.id)"
                                            :tooltipText="item.estado == false ? 'Notificación sin leer' : 'Notificación leída'"
                                            :iconBut="item.estado == false ? 'far fa-question-circle' : 'far fa-check-circle'"
                                            :classColor="item.estado == false ? 'success' : 'grey'" />
                                    </v-col>
                                    <v-col cols="12" class="py-0 d-flex caption font-weight-medium">
                                        {{ item.contenido_notif }}
                                    </v-col>
                                    <v-col cols="12" class="py-0 d-flexalign-center">
                                        <v-chip v-if="item.desc_curso !== null && item.desc_curso !== ''" x-small label>
                                            Curso : {{ item.desc_curso }}
                                        </v-chip>
                                        <v-tooltip v-if="item.tema_clase !== null && item.tema_clase !== ''" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip x-small label v-on="on" v-bind="attrs" class="ml-2">
                                                    Tema : {{ truncateText(item.tema_clase, 15) }}
                                                </v-chip>
                                            </template>
                                            <span>
                                                {{ item.tema_clase }}
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" class="d-flex caption black--text py-0">
                                        {{ item.descripcion_perfil }} : {{ item.nombre_persona + ' ' +
                                            item.ape1_persona }}
                                    </v-col>
                                    <v-col cols="12" class="d-flex justify-end gap-10px">
                                        <v-chip label x-small>
                                            {{ item.fecha_notif | filtroFecha }}
                                        </v-chip>
                                        <v-chip label x-small>
                                            {{ item.hora_notif | filtroFormatoHora }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


    </div>
</template>
<script>
import axios, { API_URL } from "@/helpers/axios"
import { mapMutations, mapGetters, mapActions } from 'vuex';
import ButtonComp from "../components/ComponentsEst/TableButtonComp.vue";
import io from 'socket.io-client';
export default {
    name: 'notification',
    components: {
        ButtonComp
    },
    data: () => ({
        rutaservidor: API_URL,
        datoLogin: sessionStorage,
        notificationslist: [],
        countUnread: 0
    }),
    mounted() {
        this.loadMain();
        this.socket = io(API_URL);
        this.socket.on('notifActualizado', () => {
            // console.log('estoy en mounted');
            this.loadMain();
        });
    },
    beforeDestroy() {
        this.socket.off('notifActualizado');
        this.socket.disconnect();
    },
    computed: {
        ...mapGetters('login', ['componenteEvento']),
    },

    methods: {
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ...mapActions('login', ['parametroComponente']),

        async loadMain() {
            this.getnotifications();
        },

        async getnotifications() {
            try {
                let response = await axios.get(`/notification/persona/${this.datoLogin.id}`);
                this.notificationslist = response.data;
                let unread = this.notificationslist.filter(item => item.estado === false)
                this.countUnread = unread.length
                this.$emit('update-unread-count', this.countUnread);

            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        truncateText(text, maxLength) {
            if (text && text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        async readNotif(id) {
            try {
                let response = await axios.post(`/notification/persona/readNotif/${id}`);
                this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null });
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        async readallNotif(id_alumno) {
            try {
                let response = await axios.post(`/notification/persona/readallNotif/${id_alumno}`);
                this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null });
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        }

    }
}
</script>